import React from "react";
import { PageIntro, SectionCard, StatusBadge } from "../../components/goldbot/GoldBotCards";
import {
  buildStrategyCards,
  getStrategiesState,
} from "../../components/goldbot/goldBotStrategyViewModel";
import { useGoldBotStrategies } from "../../hooks/useGoldBotStrategies";

function GoldBotStrategies() {
  const { data, error, isLoading } = useGoldBotStrategies();
  const state = getStrategiesState({ data, error, isLoading });
  const strategies = data && !error ? buildStrategyCards(data.strategies) : [];

  return (
    <>
      <PageIntro eyebrow="Trading engine" title="Strategies" description="Monitor strategy status, configuration, and headline results." />
      <div className="goldbot-strategies">
        {state.message ? (
          <SectionCard title="Registered Strategies" eyebrow={state.eyebrow}>
            <p className="goldbot-empty">{state.message}</p>
          </SectionCard>
        ) : (
          strategies.map((strategy) => (
            <SectionCard key={strategy.key} title={strategy.name} eyebrow={strategy.eyebrow}>
              <div className="goldbot-strategy-status"><span>Engine status</span><StatusBadge label={strategy.status} tone={strategy.tone} /></div>
              <dl className="goldbot-strategy-stats">
                {strategy.stats.map((stat) => (
                  <div key={stat.label}><dt>{stat.label}</dt><dd>{stat.value}</dd></div>
                ))}
              </dl>
            </SectionCard>
          ))
        )}
      </div>
    </>
  );
}

export default GoldBotStrategies;
